
import { defineComponent, ref, onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import Countdown from "vue3-countdown";
import CustomAudio from "@/components/CustomAudio.vue";
import ChoiceQuestion from "@/components/ChoiceQuestion.vue";
import MultipleQuestion from "@/components/MultipleQuestion.vue";
import TrueOrFalseQuestion from "@/components/TrueOrFalseQuestion.vue";
export default defineComponent({
  components: {
    Countdown,
    CustomAudio,
    ChoiceQuestion,
    MultipleQuestion,
    TrueOrFalseQuestion,
  },
  setup() {
    const route = useRoute();
    let picUrl: any = ref("");
    let dxquestion: any = ref({});
    let question: any = ref({});
    let pdquestion: any = ref({});
    picUrl.value = route.query.PIC;

    const changePartsAnswer = (params: any) => {
      console.log("params", params);
    };
    onBeforeMount(() => {
      // 单选
      pdquestion.value = {
        answer_params: {
          // 答案参数
          option_id: 3,
        },
        index: 1,
        id: 105,
        title:
          '<div>请听歌曲，判断这首歌请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的曲是几拍子的？<kbd>﻿<audio src="https://devppublic.jilingshu.com.cn/resource_center/official/20211221/%E4%BA%BA%E6%95%99%E4%B8%80%E4%B8%8A-%E5%BD%9D%E5%AE%B6%E5%A8%83%E5%A8%83%E7%9C%9F%E5%B9%B8%E7%A6%8F-vc-upload-1640077691067-2.mp3" controls="controls" style="height: 2.25em"></audio>﻿</kbd><span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span></div>',
        type: 1,
        score: 5,
        max_diff_score: "0.00",
        level: 0,
        correct_option: {
          option_id: -6,
        },
        analysis: "",
        question_params: {
          options: [
            {
              content: "<div>3/4</div>",
              is_correct: 1,
              option_id: 1,
            },
            {
              content: "<div>4/4</div>",
              is_correct: 0,
              option_id: 2,
            },
            {
              content: "<div>1/2</div>",
              is_correct: 0,
              option_id: 3,
            },
            {
              content: "<div>6/8</div>",
              is_correct: 0,
              option_id: 4,
            },
            {
              content: "<div>61/8</div>",
              is_correct: 0,
              option_id: 5,
            },
            {
              content: "<div>62/8</div>",
              is_correct: 0,
              option_id: 6,
            },
            {
              content: "<div>63/8</div>",
              is_correct: 0,
              option_id: 7,
            },
          ],
        },
        visibility: 0,
        alias_name: "第1小题",
        tags: [],
      };
      // 多选
      dxquestion.value = {
        answer_params: {
          // 答案参数
          option_ids: [1, 3],
        },
        index: 1,
        id: 106,
        title:
          '<div>请听歌曲，判断这首歌请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的曲是几拍子的？<kbd>﻿<audio src="https://devppublic.jilingshu.com.cn/resource_center/official/20211221/%E4%BA%BA%E6%95%99%E4%B8%80%E4%B8%8A-%E5%BD%9D%E5%AE%B6%E5%A8%83%E5%A8%83%E7%9C%9F%E5%B9%B8%E7%A6%8F-vc-upload-1640077691067-2.mp3" controls="controls" style="height: 2.25em"></audio>﻿</kbd><span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span></div>',
        type: 2,
        score: 10,
        max_diff_score: "0.00",
        level: 1,
        correct_option: {
          option_ids: [-1, -2, -3, -4],
        },
        analysis: "",
        question_params: {
          options: [
            {
              content: "<div>海顿</div>",
              is_correct: 1,
              option_id: 1,
            },
            {
              content: "<div>莫扎特</div>",
              is_correct: 1,
              option_id: 2,
            },
            {
              content: "<div>贝多芬</div>",
              is_correct: 1,
              option_id: 3,
            },
            {
              content: "<div>柴可夫斯基</div>",
              is_correct: 1,
              option_id: 4,
            },
            {
              content: "<div>海顿</div>",
              is_correct: 1,
              option_id: 5,
            },
            {
              content: "<div>莫扎特</div>",
              is_correct: 1,
              option_id: 6,
            },
            {
              content: "<div>贝多芬</div>",
              is_correct: 1,
              option_id: 7,
            },
            {
              content: "<div>柴可夫斯基</div>",
              is_correct: 1,
              option_id: 8,
            },
          ],
        },
        visibility: 0,
        alias_name: "第2小题",
        tags: [],
      };
      // 判断
      question.value = {
        answer_params: {
          // 答案参数
          is_correct: 0,
        },
        index: 10,
        id: 340,
        title:
          '<div>请听歌曲，判断这首歌请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的请听歌曲，判断这首歌曲是几拍子的曲是几拍子的？<kbd>﻿<audio src="https://devppublic.jilingshu.com.cn/resource_center/official/20211221/%E4%BA%BA%E6%95%99%E4%B8%80%E4%B8%8A-%E5%BD%9D%E5%AE%B6%E5%A8%83%E5%A8%83%E7%9C%9F%E5%B9%B8%E7%A6%8F-vc-upload-1640077691067-2.mp3" controls="controls" style="height: 2.25em"></audio>﻿</kbd><span style="color: rgb(159, 171, 183);">请点击按钮播放</span><span style="color: black;"> </span></div>',
        type: 4,
        score: 10,
        max_diff_score: "0.00",
        level: 1,
        correct_option: {
          is_correct: 0,
        },
        analysis: "<div>十九世纪就</div>",
        question_params: {
          is_correct: 0,
        },
        visibility: 0,
        alias_name: "第1小题",
        tags: [],
      };
    });

    return { picUrl, question, changePartsAnswer };
  },
});
